import React, { Fragment, useRef, useState, useEffect } from 'react'
import { PostData} from '../Services/httpHandelars'

import { Dialog, Transition } from '@headlessui/react'
import Snackbar from '../Components/Snackbar';

const DeactivateUserModal = (props) => {

    const { openDeactivate, setOpenDeactivate, id, setID } = props;
    const cancelButtonRef = useRef(null)

    const [snacBar, setSnacBar] = useState({ snacStatus: false, message: "", snackType: "" })

    useEffect(
        () => {
            if (snacBar.snacStatus === true) {
                setTimeout(() => setSnacBar(false), 3000);
            }
        },

        [snacBar.snacStatus]
    );

    const handleClose = () => {
        setOpenDeactivate({modalStatus: false, modalButton: "No"})
        setID("")
    }

    const handleDeactivateApi = () => {
        PostData("/api/user/deactivateUser", { _id:id}).then((data) => {
            if (data.status === true) {
                console.log("sdffgh---------------------------------")
                setSnacBar({
                  ...snacBar,
                  snacStatus: data.status,
                  message: data.message,
                  snackType: "Success"
                })
                setOpenDeactivate({modalStatus: false, modalButton: "Yes"})
            } else {
                setSnacBar({
                    ...snacBar,
                    snacStatus: data.status,
                    message: data.message,
                    snackType: "Error"
                })
                setOpenDeactivate({modalStatus: false, modalButton: "No"})
            }
        });
    }
    return (
        <Transition.Root show={openDeactivate} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleClose} >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed z-10 inset-0 overflow-y-auto">
                    <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-2">
                                        <div className="mt-10 sm:mt-0">
                                            <div className='font-medium flex justify-start'>
                                                Deactivate User
                                            </div>
                                            <div className='border-t border-gray-400 mt-1 mb-4'></div>
                                            <h1 className='flex justify-center'>Are you sure you want to Deactivate this user</h1>
                                            <div className='flex justify-center gap-3 mt-5 mb-5'>

                                                <button
                                                    type='submit'
                                                    className='inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
                                                    onClick={
                                                        handleDeactivateApi
                                                    }
                                                >
                                                    Yes
                                                </button>
                                                
                                                <button
                                                    onClick={handleClose}
                                                    className='inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-400 hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500'
                                                >
                                                    No
                                                </button>

                                            </div>
                                        </div>
                                </div>

                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>

        {snacBar?.snacStatus &&
        <Snackbar snackType={snacBar?.snackType} message={snacBar.message} style={true} />
        }
            </Dialog>
        </Transition.Root>
    )
}

export default DeactivateUserModal